import {NOT_EXISTED_PREFIX} from '../analytics.constants';
import {analytics} from '@cl/shared';
const {cachedAnalyticsSubject} = analytics;

export default function getAnalyticsUIName(key: string, showPrefix = false): string {
  const name = cachedAnalyticsSubject.data.uiNameMapping[key];

  if (!name) return null;

  return `${showPrefix ? NOT_EXISTED_PREFIX : ''}${name}`;
}
